import React, { useState, useEffect } from 'react';
import getDeviceType from './../../utils/getDeviceType';
import IcArrowMin from './../../assets/icon/ic-arrow-min.svg';

const osList = ['android', 'ios'];

const Wifi = () => {
  const [tabvalue, setTabvalue] = useState('android');
  const [infoMoreValue, setInfoMoreValue] = useState(false);

  const changeTabvalue = (value) => {
    setTabvalue(value);
  }

  const changeInfoNoreTabvalue = (e) => {
    setInfoMoreValue(prevValue => !prevValue);
  }

  useEffect(() => {
    let type = getDeviceType();
    if (type === "pc"){type = "android"}
    setTabvalue(type);
  }, []); 

  return (
  <>
    <section id="container" className="wrap">
      <div className="paragraph">
        <h1 className="subject"><strong>SKYTONE</strong></h1>
        <h2 className="title">Wi-Fi 설정</h2>
        <p className="desc">제품을 사용하려면 스마트폰이나 PC를 이용하여 스카이톤에 접속하고 Wi-Fi 설정을 해야 합니다.</p>
        <p className="desc">
          <span className="bu">- Wi-Fi 로 <strong>SKYTONE</strong>을 연결 후,</span>
          <span className="bu">- 인터넷 Wi-Fi 접속 정보를 입력 합니다.</span>
          <span className="bu">- 이후 IP를 통하여 내 기기에 접속 할 수 있습니다. </span>
        </p>
      </div>   
      <div className="button-box tab">
        <button className={`btn ${tabvalue === osList[0] ? 'active-tab' : ''}`} name="page-content" onClick={() => changeTabvalue(osList[0])}><span className="name">안드로이드</span></button>
        <button className={`btn ${tabvalue === osList[1] ? 'active-tab' : ''}`} name="page-content" onClick={() => changeTabvalue(osList[1])}><span className="name">iOS</span></button>
      </div>
      <div className={`page-content ${tabvalue === osList[0] ? '':'hidden'}`} data-name={osList[0]}>
        <div className="content-group">                        
          <div className="paragraph">
            <p className="step">01</p>
            <p className="desc">Wi-Fi 목록 화면에서 <strong>SKYTONE</strong>을 선택합니다.</p>
          </div>
          <div className="screenshot">
            <img src={process.env.PUBLIC_URL + '/skytone_src/a_setup_00.png'} alt=""/>
            <span className="click-area" style={{left:'3%',width:'94%',top:'48%',height:'22%'}}></span>
          </div>       
        </div> 
        <div className="content-group">                                 
          <div className="paragraph">
            <p className="step">02</p>
            <p className="desc">경고창이 노출되면 <strong>이번만 연결</strong> 또는 <strong>항상 연결</strong>을 선택해 네트워크 연결을 계속합니다.</p>
          </div>        
          <div className="screenshot">
            <img src={process.env.PUBLIC_URL + '/skytone_src/a_setup_01.png'} alt=""/>
            <span className="click-area" style={{left:'12%',width:'76%',top:'56%',height:'22%'}}></span>
          </div>    
        </div> 
        <div className="content-group">                                 
          <div className="paragraph">
            <p className="step">03</p>
            <p className="desc">잠시 후 자동으로 화면이 전환되며 브라우저에 접속합니다.<br/><br/>만약 화면이 바뀌지 않으면<br/>직접 <strong>인터넷 브라우저</strong>를 열어 주소창에<br/><strong>192.168.4.1</strong>을 입력하고 접속합니다.</p>
          </div>        
          <div className="screenshot">
            <img src={process.env.PUBLIC_URL + '/skytone_src/a_setup_02a.png'} alt=""/>
            <span className="click-area" style={{left:'3%',width:'94%',top:'15%',height:'70%'}}></span>
          </div>    
        </div> 
        <div className="content-group">                                 
          <div className="paragraph">
            <p className="step">04</p>
            <p className="desc">브라우저 화면에 경고 문구가 노출되면,<br/><strong>사이트로 이동</strong>을 선택합니다.</p>
          </div>        
          <div className="screenshot">
            <img src={process.env.PUBLIC_URL + '/skytone_src/a_setup_03.png'} alt=""/>
            <span className="click-area" style={{left:'12%',width:'76%',top:'83%',height:'15%'}}></span>
          </div>    
        </div> 
      </div>
      <div className={`page-content ${tabvalue === osList[1] ? '':'hidden'}`} data-name={osList[1]}>
        <div className="content-group">                        
          <div className="paragraph">
            <p className="step">01</p>
            <p className="desc">Wi-Fi 설정 화면에 진입합니다.</p>
          </div>
          <div className="screenshot">
            <img src={process.env.PUBLIC_URL + '/skytone_src/i_setup_00.png'} alt=""/>
            <span className="click-area" style={{left:'1%',width:'98%',top:'0%',height:'18%'}}></span>
          </div>       
        </div> 
        <div className="content-group">                                 
          <div className="paragraph">
            <p className="step">02</p>
            <p className="desc">Wi-Fi 목록 화면에서 <strong>SKYTONE</strong>을 선택합니다.</p>
          </div>        
          <div className="screenshot">
            <img src={process.env.PUBLIC_URL + '/skytone_src/i_setup_01.png'} alt=""/>
            <span className="click-area" style={{left:'5%',width:'90%',top:'25.3%',height:'16%'}}></span>
          </div>    
        </div> 
        <div className="content-group">                                 
          <div className="paragraph">
            <p className="step">03</p>
            <p className="desc">선택 후 자동으로 <strong>Wi-Fi 세팅 화면</strong>으로 이동합니다.<br/>Wi-Fi 목록을 읽어올 때까지 잠시 기다려 주세요.<br/><br/>만약 자동으로 화면이 전환되지 않으면<br/>직접 <strong>브라우저</strong>를 열어 주소창에<br/><strong>192.168.4.1</strong>을 입력해 접속합니다.</p>
          </div>           
          <div className="screenshot">
            <img src={process.env.PUBLIC_URL + '/skytone_src/i_setup_02.png'} alt=""/>
            <span className="click-area" style={{left:'5%',width:'90%',top:'57%',height:'36%'}}></span>
          </div>       
          <div className="screenshot">
            <img src={process.env.PUBLIC_URL + '/skytone_src/i_setup_03a.png'} alt=""/>
            <span className="click-area" style={{left:'1%',width:'98%',top:'1%',height:'98%'}}></span>
          </div>
        </div> 
        <div className="content-group">                                 
          <div className="paragraph">
            <p className="step">04</p>
            <p className="desc"><strong>Wi-Fi 세팅 화면</strong>에 접속했으면,<br/>다음 단계를 진행합니다.</p>
            <div className={`accordion-item ${infoMoreValue? 'opened':''}`}data-idx="1">                     
              <button type="button" className="subject" name="accordion" onClick={changeInfoNoreTabvalue}>
                <p className="desc">만약, SKYTONE <strong>연결이 자동 해제된다면</strong> 이 곳을 클릭하세요.</p>
                <p className="arrow"><img src={IcArrowMin} alt="Open / Close" className="svg"/></p>
              </button>
              <div className="content">
                <p className="desc">ⓘ 표시를 눌러 <strong>[이 네트워크 지우기]</strong>를 실행합니다.</p> 
                <div className="screenshot">
                  <img src={process.env.PUBLIC_URL + '/skytone_src/i_setup_02.png'} alt=""/>
                  <span className="click-area" style={{left:'auto',right:'4.5%',width:'14%',top:'57%',height:'36%'}}></span>
                </div>   
                <div className="screenshot">
                  <img src={process.env.PUBLIC_URL + '/skytone_src/i_setup_03b.png'} alt=""/>
                  <span className="click-area" style={{left:'5%',width:'90%',top:'30%',height:'26%'}}></span>
                </div>    
                <p className="desc">이 다음, SKYTONE 연결을 다시 시도해 보세요.</p> 
              </div>       
            </div>
          </div>    
        </div> 
      </div>
      <div className="page-content" data-name="all">
        <div className="content-group">                                 
          <div className="paragraph">
            <p className="step">05</p>
            <p className="desc">연결 가능한 Wi-Fi 목록이 출력되었습니다!<br/>연결할 Wi-Fi를 선택하세요.</p>
          </div>        
          <div className="screenshot">
            <img src={process.env.PUBLIC_URL + '/skytone_src/a_setup_04.png'} alt=""/>
            <span className="click-area" style={{left:'12%',width:'76%',top:'43%',height:'55%'}}></span>
          </div>    
        </div> 
        <div className="content-group">                                 
          <div className="paragraph">
            <p className="step">06</p>
            <p className="desc"><strong>Wi-Fi 비밀번호</strong> 및 <strong>지역</strong>을 입력하세요.<br/>모두 맞게 입력하셨다면, <strong>SAVE</strong> 버튼을 눌러 저장합니다.</p>
          </div>        
          <div className="screenshot">
            <img src={process.env.PUBLIC_URL + '/skytone_src/a_setup_05-1.png'} alt=""/>
            <span className="click-area" style={{left:'12%',width:'76%',top:'24%',height:'58%'}}></span>
            <span className="click-area" style={{left:'6%',width:'88%',top:'83.5%',height:'14%'}}></span>
          </div>    
        </div>  
        <div className="content-group">                                 
          <div className="paragraph">
            <p className="step">07</p>
            <p className="desc">네트워크 상태에 따라 저장될 때까지 1~2분 가량 소요될 수 있습니다.<br/>창을 닫지 마시고 기다려 주세요.</p>
          </div>        
          <div className="screenshot">
            <img src={process.env.PUBLIC_URL + '/skytone_src/a_setup_05-2.png'} alt=""/>
          </div>    
        </div> 
        <div className="content-group">                                 
          <div className="paragraph">
            <p className="step">08</p>
            <p className="desc">저장이 완료되면 <strong>고유 IP</strong>를 확인하세요.<br/>야간모드 등 추가 설정을 위해서는 브라우저에서 고유 IP를 입력하여 설정 페이지에 접근하세요.<br/><br/><small>※ 고유 IP는 지속적으로 사용되므로 잊어버리지 않도록 주의하세요.</small></p>
          </div>        
          <div className="screenshot">
            <img src={process.env.PUBLIC_URL + '/skytone_src/a_setup_06.png'} alt=""/>
            <span className="click-area" style={{left:'12%',width:'76%',top:'62.5%',height:'14%'}}></span>
          </div>    
        </div>
        <div className="content-group">                        
          <div className="paragraph">
            <p className="step">09</p>
            <p className="desc">Wi-Fi 연결 시 청록색 불빛이 깜빡입니다.<br/>연결이 완료되면 깜빡임이 멈추고 대기 정보가 표시됩니다.<br/><br/><small>※ 네트워크 상태에 따라 연결 시간이 달라질 수 있으니,<br />3분 이상 지연되면 USB를 다시 연결해 주세요.</small></p>
          </div>
          <div className="screenshot w100">
            <img src={process.env.PUBLIC_URL + '/skytone_src/light-finding.png'} alt=""/>
          </div>
        </div> 
      </div>
      <span className="empty-space"></span>
    </section>
  </>
  );
};

export default Wifi;